import { Num } from "@/components/Num";
import { TrendingUp, TrendingDown } from "lucide-react";
import { fmtPct } from "@/lib/format";

const Card = ({ title, fy, bud, varPct, sub, testid, i }) => {
  const up = (varPct || 0) >= 0;
  return (
    <div className={`bg-white border border-slate-200 rounded-lg p-5 rise rise-${i}`} data-testid={testid}>
      <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{title}</p>
      <p className="font-heading text-2xl sm:text-3xl font-bold text-slate-900 mt-2 tabular"><Num v={bud} compact /></p>
      <div className="mt-2 flex items-center justify-between text-xs">
        <span className="text-slate-500">FY est: <span className="font-mono text-slate-700"><Num v={fy} compact /></span></span>
        {varPct !== null && varPct !== undefined && (
          <span className={`inline-flex items-center gap-1 font-semibold ${up ? "text-emerald-600" : "text-red-600"}`}>
            {up ? <TrendingUp size={13} /> : <TrendingDown size={13} />} {fmtPct(varPct)}
          </span>
        )}
      </div>
      {sub && <p className="text-[11px] text-slate-400 mt-1">{sub}</p>}
    </div>
  );
};

export const KpiCards = ({ kpis, budgetYear, notes }) => {
  if (!kpis) return null;
  const { revenue, gop, ebitda, nop, payroll } = kpis;
  return (
    <div className="space-y-3">
    <div className="grid sm:grid-cols-2 xl:grid-cols-5 gap-4" data-testid="kpi-cards">
      {revenue && <Card i={1} title={`Total Revenue ${budgetYear}`} fy={revenue.fy_total} bud={revenue.budget_total} varPct={revenue.var_pct} sub={revenue.label} testid="kpi-total-revenue" />}
      {gop && <Card i={2} title="Gross Operating Profit" fy={gop.fy_total} bud={gop.budget_total} varPct={gop.var_pct} sub={kpis.gop_margin_budget !== undefined ? `GOP margin ${kpis.gop_margin_fy != null ? kpis.gop_margin_fy.toFixed(2) + "% → " : ""}${kpis.gop_margin_budget?.toFixed(2)}%` : gop.label} testid="kpi-gop-margin" />}
      {payroll && <Card i={3} title="Payroll" fy={payroll.fy_total} bud={payroll.budget_total} varPct={payroll.var_pct} sub={kpis.payroll_pct_budget !== undefined ? `Payroll ${kpis.payroll_pct_fy !== undefined ? kpis.payroll_pct_fy.toFixed(2) + "% → " : ""}${kpis.payroll_pct_budget?.toFixed(2)}% of revenue` : payroll.label} testid="kpi-payroll" />}
      {ebitda && <Card i={4} title="EBITDA" fy={ebitda.fy_total} bud={ebitda.budget_total} varPct={ebitda.var_pct} sub={ebitda.label} testid="kpi-ebitda" />}
      {nop && <Card i={5} title="NOP (after FF&E reserve)" fy={nop.fy_total} bud={nop.budget_total} varPct={nop.var_pct} sub={nop.label.replace(/ \(computed — USALI\)/, "")} testid="kpi-nop" />}
    </div>
    {notes?.length > 0 && (
      <ul className="text-[11px] text-slate-600 bg-slate-50 border border-slate-200 rounded-lg px-4 py-2 space-y-1" data-testid="usali-notes">
        {notes.map((n, i) => <li key={i} data-testid={`usali-note-${i}`}>{n}</li>)}
      </ul>
    )}
    </div>
  );
};
